import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Checkbox } from 'antd';
import './ReasonCodeList.scss';
import ChevronDownIcon from 'Components/icons/ChevronDownIcon';
import { Collapse } from 'react-collapse';

class ReasonCodeList extends Component {
  constructor(props) {
    super(props);
    this.toggleCollapse = this.toggleCollapse.bind(this);
    this.handleHeaderCheckChange = this.handleHeaderCheckChange.bind(this);
  }

  toggleCollapse(item) {
    this.props.toggleCollapse(item);
  }

  handleHeaderCheckChange = (item) => (e) => {
    item.selected = e.target.checked;
    this.props.handleHeaderCheckbox(item, this.props.filterName);
  }

  handleCheckChange = (item) => {
    this.props.handleChange(item, this.props.filterName);
    this.props.updateIsIndeterminate(this.props.dataList);
  }

  checkBrowser() {
    const ua = window.navigator.userAgent;
    const isIE = ua.indexOf('Trident/') || ua.indexOf('MSIE');
    return isIE;
  }

  resetScroll = () => {
    if(this.props.isMreFilterPaneVisible && this.props.isMreFilterPaneVisible === false) {
        const divElement = document.getElementsByClassName('reason-code-selection-list-items');
        divElement.scrollIntoView({ behavior: 'smooth'});
    } 
  }

  render() {
    if(this.props.elementId === 'mre_reason_code') {
      this.resetScroll();
    }
    const listWidth = this.checkBrowser() > 0 ? 369 : 325;
    const items = this.props.dataList && this.props.dataList.map((item) => {
      return (
        <li className="reason-code-selection-list-item" role="menuitem" key={item.key} tabIndex={0}>
          <div className="item-header">
            <span className="mr-5" role="button" onClick={() => { this.toggleCollapse(item) }}> <ChevronDownIcon width='10' height='9' transform={item.isExpanded ? 'rotate(0)' : 'rotate(-90)'} /> </span>
            {this.props.elementId !== "cq_base_queue" &&
              <Checkbox
                indeterminate={item.isIndeterminate}
                onChange={this.handleHeaderCheckChange(item)}
                checked={item.selected}
                disabled = {this.props.disabled}
              >
              </Checkbox>
            }
            <div className="group" role="button" onClick={() => { this.toggleCollapse(item) }}>
              {item.key}
            </div>
            <div className="subtitle" role="button" onClick={() => { this.toggleCollapse(item) }}></div>
          </div>
          <Collapse isOpened={item.isExpanded}
            initialStyle={item.isExpanded
              ? { height: 'auto', overflow: 'initial' }
              : { height: '0px', overflow: 'hidden' }}
          >
            <div className="display-content">
              {item.items.map((child) => {
                const key = `${item.key}_${child.id}`
                return (
                  <span id="label" key={key} className="vertical-nav-label">
                    <Checkbox onChange={() => { this.handleCheckChange(child); }}
                      checked={child.selected} disabled = {this.props.disabled}>
                      {child.text}
                    </Checkbox>
                  </span>
                )
              })}
            </div>
          </Collapse>
        </li>
      );
    });



    return (
      <Collapse isOpened={this.props.visible}
        id={this.props.filterName}
        style={{ width: listWidth }}

        className="list-rc">
        <div className={classNames('reason-code-selection-list', {
          'group-search-open': this.props.visible
        })}>
          <ol className="reason-code-selection-list-items">
            {items}
          </ol>
        </div>
      </Collapse>
    )
  }

};

ReasonCodeList.propTypes = {
  dataList: PropTypes.array.isRequired,
  extraClass: PropTypes.string,
  visible: PropTypes.bool,
  searchTerm: PropTypes.string,
  handleChange: PropTypes.func,
  handleHeaderCheckbox: PropTypes.func,
  toggleCollapse: PropTypes.func
};

ReasonCodeList.defaultProps = {
  extraClass: '',
  searchTerm: '',
  dataList: [],
};

export default ReasonCodeList;
